
import { wrap } from "@codeArt/utils/promise";

export function initialize(){
    return wrap((resolve, reject) => {
        //以后再用
        resolve();
    });
}